var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5V2C14 0 12.1 0 11 0H3C1.9 0 0 0 0 2V5V11V20H2V15L3 17V20H11V17L12 15V20H14V11V5ZM2 2H12V4H9H8H6H5H2V2ZM12 10.53L9 16.53V18H5V16.53L2 10.53V10H12V8H2V6H12V10.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilosIcon);
export default __webpack_public_path__ + "static/media/SilosIcon.f701f849ab93c769dff5208ccc55a9cf.svg";
export { ForwardRef as ReactComponent };